import React from "react";

import { formatBrazilianCurrency } from "shared/utils/formatBrazilianCurrency";

import useCheckoutStepsOffersContext from "@payment/pages/CheckoutStepsOffers/provider";
import { useCheckoutContext } from "@payment/providers/CheckoutProvider/useCheckoutContext";

import Coupon from "./components/Coupon";
import FinalPrices from "./components/FinalPrices";
import FinalPricesOrderBump from "./components/FinalPricesOrderBump";
import MainContent from "./components/MainContent";
import MainContentOrderBump from "./components/MainContentOrderBump";
import MoreInformations from "./components/MoreInformations";
import { Column, Container, SectionTitle } from "./styles";

const ProductInfo = () => {
  const { installments, orderBumpsSelected } = useCheckoutStepsOffersContext();
  const { country } = useCheckoutContext();

  const lastInstallment = installments[installments?.length - 1];

  const textForInstallmentAmountVisualization =
    country === "Brasil"
      ? `${lastInstallment?.installment}x de ${formatBrazilianCurrency(
          lastInstallment?.value,
        )}${lastInstallment?.free_installment ? " sem juros" : "*"}`
      : `1 x ${formatBrazilianCurrency(installments[0]?.value)} `;

  return (
    <Column>
      <Container>
        <SectionTitle>Resumo da compra</SectionTitle>

        {orderBumpsSelected?.length > 0 ? (
          <MainContentOrderBump
            textForInstallmentAmountVisualization={
              textForInstallmentAmountVisualization
            }
          />
        ) : (
          <MainContent
            textForInstallmentAmountVisualization={
              textForInstallmentAmountVisualization
            }
          />
        )}
        <Coupon />

        {orderBumpsSelected?.length > 0 ? (
          <FinalPricesOrderBump
            textForInstallmentAmountVisualization={
              textForInstallmentAmountVisualization
            }
          />
        ) : (
          <FinalPrices
            textForInstallmentAmountVisualization={
              textForInstallmentAmountVisualization
            }
          />
        )}
      </Container>

      <MoreInformations />
    </Column>
  );
};

export default ProductInfo;
